<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="dnsTicketModal" tabindex="-1" role="dialog" aria-labelledby="dnsTicketModalLabel">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="dnsTicketModalLabel">
              Create DNS Ticket
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="loading" class="loader"></div>
            <section v-else>
<!--              <section>-->
<!--                <div v-if="tickets.length>0" class="row">-->
<!--                  <div  class="col-md-12">-->
<!--                    <h5>Recently Created Tickets:</h5>-->
<!--                    <ul>-->
<!--                      <li v-for="(row, index) in tickets" :key="index">-->
<!--                        {{formatDate(row.createdAt)}} <b>|</b> Subject: {{row.subject}}-->
<!--                      </li>-->
<!--                    </ul>-->
<!--                    <hr>-->
<!--                  </div>-->
<!--                  <br>-->
<!--                </div>-->
<!--              </section>-->
              <section>
                <form @submit.prevent="submit">
                  <div class="row">
                    <div class="col-md-12">
                      <label>Subject:</label>
                      <input type="text" v-model="subject" name="subject" class="form-control" />
                    </div>
                  </div>
                  <section >
                    <div class="row mt-3" >
                      <div class="col-md-6">
                        <label>Message:</label>
                        <textarea class="form-control" rows="8" v-model="ticketMessage"></textarea>
                      </div>
                      <div class="col-md-6">
                        <label>Presets:</label>
                        <ul class="list-unstyled preset">
                          <li v-for="(macro, index) of presetMacros" :key="index" @click="useThisMacro(macro)">
                            <h6><span v-html="(macro.title)? macro.title : ''"></span></h6>
                            <span v-html="(macro.message) ? macro.message.split('\n')[0].substr(0,40).replace(/\n/g,'<br>') + '...' : macro.split('\n')[0].substr(0,40).replace(/\n/g,'<br>')"></span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <label>Select Status:</label>
                        <select class="form-control" v-model="ticketStatus">
                          <option value="Open">Open</option>
                          <option value="Closed">Closed</option>
                          <option value="Client-Reply">Client-Reply</option>
                          <option value="In-Progress">In-Progress</option>
                          <option value="Answered">Answered</option>
                          <option value="Pending Client">Pending Client</option>
                          <option value="Follow Up">Follow Up</option>
                        </select>
                      </div>
                      <div class="col-md-6">
                        <label>Select Priority:</label>
                        <select class="form-control" v-model="ticketPriority">
                          <option value="High">High</option>
                          <option value="Low">Low</option>
                          <option value="Medium">Medium</option>
                        </select>
                      </div>
                    </div>
                  </section>
<!--                  <div class="row">-->
<!--                    <div class="col-md-12 ml-3 mt-3">-->
<!--                      <input class="form-check-input" type="checkbox" v-model="assignTicketUrl" /> Assign Ticket URL?-->
<!--                    </div>-->
<!--                  </div>-->
                  <div class="row">
                    <div class="col-md-12">
                      <button class="btn btn-sm btn-primary pull-right" type="submit" :disabled="loading">Submit</button>
                    </div>
                  </div>
                </form>
              </section>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {db} from "@/firebase/init";
import swal from "sweetalert2";

export default {
  name: "dnsTicketModal",
  data(){
    return {
      ticketMessage: null,
      ticketStatus: 'Pending Client',
      ticketPriority: 'Low',
      subject: '',
      type: null,
      loading: false,
      presetMacros: [],
      migrationData: {},
      tickets: [],
      assignTicketUrl: false
    }
  },
  mounted() {
    // Component mounted
  },
  computed: {
    user () {
      return this.$store.getters.user;
    }
  },
  methods: {
    formatDate(date){
      return moment(date).local().fromNow()
    },
    async getTickets(){
      this.tickets = [];
      if (this.migrationData && this.migrationData.id) {
        let ticketRef=await db.collection('dnsTickets').doc(this.migrationData.id.toString()).get()
        if(ticketRef.exists){
          const {tickets} = ticketRef.data()
          this.tickets= tickets || []
        }
      }
    },
    async useThisMacro (macro) {
      this.loading = true
      let msg = (macro.message) ? macro.message : macro;
      if (this.migrationData && this.migrationData.uid) {
        const userRef = await db.collection('users').doc(this.migrationData.uid).get()
        const haRef = await db.collection('hostingAccounts').doc(this.migrationData.uid).get()
        let cfEmail = ''
        if(userRef.exists){
          const { accounts } = haRef.data()
          const selectedAcc = accounts.find(el => el.primary.hbHostname === this.migrationData.hostname);
          if(selectedAcc) {
            cfEmail = selectedAcc.primary.cloudflare.username
          }
        }
        if (userRef.exists) {
          const user = userRef.data()
          msg = msg.replace(/{firstName}/g, user.firstName || '')
          msg = msg.replace(/{lastName}/g, user.lastName || '')
          msg = msg.replace(/{domain}/g, this.migrationData.hostname || '')
          msg = msg.replace(/{signature}/g, this.user.signature || '')
          msg = msg.replace(/{hostname}/g, this.migrationData.hostname || '')
          msg = msg.replace(/{ip}/g, this.migrationData.ip || '')
          msg = msg.replace(/{lxdIp}/g, this.migrationData.lxdIp || 'N/A')
          msg = msg.replace(/{cloudflareEmail}/g, cfEmail || 'N/A')
        }
      }
      this.ticketMessage = msg;
      this.ticketStatus = 'Follow Up';
      this.ticketPriority = 'Low';
      this.subject= macro.title.replace('({domain})', '') || ''
      this.loading = false
    },
    async load (presets, migrationData) {
      this.migrationData = {}
      this.ticketMessage = ''
      this.ticketStatus = ''
      this.subject = ''
      this.presetMacros=presets.filter(el => el.title.includes('Action Required:') || el.title === 'Action Needed: DNS / Cloudflare Access for Upcoming Upgrade')
      this.migrationData=migrationData || {}
      // await this.getTickets()
      $('#dnsTicketModal').modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
    async submit () {
      try {
        this.loading = true
        if (!this.migrationData || !this.migrationData.uid) {
          throw new Error('Migration data is missing')
        }
        let accountRef = await db.collection('users').doc(this.migrationData.uid).get();
        if (!accountRef.exists) {
          throw new Error('User account not found')
        }
        accountRef = accountRef.data();
        let response=await this.$http.post('host-bill/open-new-ticket', {
          grant_type: 'token',
          message: this.ticketMessage,
          priority: this.ticketPriority,
          clientID: accountRef.customerID,
          subject: this.subject,
          status: this.ticketStatus,
          name: this.user.firstName + ' ' + this.user.lastName
        })

        console.log('response', response)
        await this.$http.post('/host-bill/add-ticket-tag', {
          ticketId: response.data.ticket_id,
          grant_type: 'token',
          tag: `LXD Migrations`
        })
        if (this.migrationData && this.migrationData.id) {
          if(!this.migrationData.ticketAndNotes) {
            this.migrationData.ticketAndNotes = []
          }
          this.migrationData.ticketAndNotes.push({ticketId:response.data.ticket_id, status: this.ticketStatus, note: '', })
          this.$emit('refreshData', this.migrationData)
          await db.collection('vzToLxdMigration').doc(this.migrationData.id.toString()).update({ticketAndNotes: this.migrationData.ticketAndNotes, dnsTicketCreated: true, createdBy: `${this.user.firstName} ${this.user.lastName}`,
            createdByEmail: this.user.email,
            createdAt: new Date().toISOString()
          })
        }
        // if(this.assignTicketUrl && this.migrationData && this.migrationData.id){
        //   await db.collection('vzToLxdMigration').doc(this.migrationData.id.toString())
        //       .update({ticket: `https://www.bigscoots.com/portal/admin/?cmd=tickets&action=view&brc=MTA&list=requirescustomerupdate&num=${response.data.ticket_id}`})
        // }
        swal({
          title: "Success",
          text: 'Ticket has been created successfully',
          type: "success"
        })
        $('#dnsTicketModal').modal('hide');

      } catch (e) {
        this.loading = false
        swal({
          title: "Error",
          text: e.toString(),
          type: "error"
        })
      }finally
      {
        this.loading = false
        this.ticketMessage=''
        this.subject=''
        $('#dnsTicketModal').modal('hide');

      }
    },
  }
}
</script>

<style lang="scss" scoped>
.preset {
  height: 230px;
  overflow: auto;
  li {
    cursor: pointer;
    border: 1px solid rgba(0,0,0,0.3);
    padding: 2px;
    background-color: rgba(0,0,0,0.1);
    border-radius: 3px;
    margin: 2px 0;
  }
}
</style>

